export default "__VITE_ASSET__DQCyL9W5__"